import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import IntlMessages from '../../components/utility/intlMessages';
import Scrollbars from '../../components/utility/customScrollBar';
import { SidebarContent, Icon } from './sidebarNotification.style';
import { Avatar } from './style';
import moment from 'moment';
import { iconFromType } from '../../helpers/notificationHelpers';


class TopbarMessage extends Component {
  state = {
    visible: false,
    anchorEl: null,
  };
  hide = () => {
    this.setState({ visible: false });
  };
  handleVisibleChange = () => {
    this.setState({
      visible: !this.state.visible,
      anchorEl: findDOMNode(this.button),
    });
  };
  render() {
    const { height, items, errorMessage } = this.props;
    return (
      <SidebarContent
        className="topbarMessage withImg"
        style={{ height: height - 65 }}
      >
        <div className="dropdownBody">
          <Scrollbars style={{ height: '100%' }}>
            {items 
              ? items.map(item => {
                const momentDate = new moment(item.ts);
                const date = momentDate.format("DD/MM/YY, h:mma")
                return (
                  <a className="dropdownListItem" key={item.id}>
                    <div className="userImgWrapper">
                      <Avatar className="blueAvatar">
                        <Icon>{iconFromType(item.type)}</Icon>
                      </Avatar>
                    </div>

                    <div className="listContent">
                      <div className="listHead">
                        <h5>{item.title}</h5>
                        <span className="date">{date}</span>
                      </div>
                      <p>{item.message}</p>
                    </div>
                  </a>
                )
              })
              : <a className="dropdownListItem">
                  <h5>{errorMessage}</h5>
                </a>
            }
          </Scrollbars>
        </div>
        <a className="viewAllBtn">
          <IntlMessages id="topbar.viewAll" />
        </a>
      </SidebarContent>
    );
  }
}

export default connect(state => ({
  ...state.App,
  customizedTheme: state.ThemeSwitcher.topbarTheme,
  height: state.App.height,
}))(TopbarMessage);



// WEBPACK FOOTER //
// ./src/containers/Topbar/topbarMessage.js